module.exports = __webpack_public_path__ + "img/frank-emory-bunts.4aa66cc9.png";